
// @ts-nocheck

import React, { useEffect, useState } from 'react'
import SoftBox from '../../../components/common/softBox';
import SoftTypography from '../../../components/common/softTypography';
import SoftInput from '../../../components/common/softInput';
import SoftButton from '../../../components/common/softButton';
import { useDispatch, useSelector } from 'react-redux';
import { editRoomType, getRoomTypeById } from '../../../features/roomType';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

         {/* @ts-ignore  */}

const EditRoomType = () => {
  {/* @ts-ignore  */}
  const { id } = useParams<{ id: string }>();
  {/* @ts-ignore  */}
  const [images, setImages] = useState([]);
  const { roomType, status } = useSelector(state => state.roomType);
console.log(status,'status');

  const dispatch = useDispatch();
  const navigate = useNavigate()

    const [formData, setFormData] = useState({
      id:id,
        name: "",
        description: "",
        base_price: 0,
        max_occupancy: "",
        size: "",
    });

    useEffect(()=>{
         {/* @ts-ignore  */}

     dispatch(getRoomTypeById(id))
    },[dispatch,id])

    useEffect(()=>{
      console.log(roomType,'roomType');
      
      if(status && roomType){
        // const data = roomType.data
            setFormData({
              id:roomType.data._id,
              name: roomType.data.name,
              description: roomType.data.description,
              base_price:roomType.data.base_price,
              max_occupancy: roomType.data.max_occupancy,
              size: roomType.data.size,
            })
            setImages(roomType.data.photos)
      }
   
    
     },[status])
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleAddImages = (event) => {
      if (event.target.files) {
        const newImages = Array.from(event.target.files);
        setImages((prevImages) => [...prevImages, ...newImages]);
      }
    };
  
    const handleRemoveImage = (index) => {
      setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    };
    const handleSubmit = () => {
      const formDataWithImages = new FormData();
      formDataWithImages.append('name', formData.name);
      formDataWithImages.append('description', formData.description);
      formDataWithImages.append('base_price', formData.base_price.toString());
      formDataWithImages.append('max_occupancy', formData.max_occupancy);
      formDataWithImages.append('size', formData.size);
      formDataWithImages.append('link', formData.link);
  
      images.forEach((image) => {
        formDataWithImages.append('photos', image);
      });

 dispatch(editRoomType({id,updatedRoomType: formDataWithImages})).then((res)=>{

  const notify = () => toast.success(res.payload.message);
  notify()
  navigate('/room-type')

}).catch((err)=>{
  console.log(err,'err');
  
})

    }

console.log(images,'images');

    return (
      
        <SoftBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgColor="white"
        shadow="lg"
        borderRadius="lg"
        p={4}
      >
    
        <SoftBox width="100%" maxWidth="400px" >

          <SoftBox mb={2}>

            <SoftTypography variant="h4" fontWeight="bold" textAlign="center" >
              Room Type
            </SoftTypography>
          </SoftBox>

          <SoftBox component="form" role="form">

            <SoftBox mb={2}>

              <SoftBox mb={1} ml={0.5}>

                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Name
                </SoftTypography>
              </SoftBox>

              <SoftInput

                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
            </SoftBox>
  
            <SoftBox mb={2}>

              <SoftBox mb={1} ml={0.5}>

                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Description
                </SoftTypography>
              </SoftBox>
              <SoftInput

                type="text"
                name="description"
                placeholder="Description"
                value={formData.description}
                onChange={handleChange}
              />
            </SoftBox>
  
            <SoftBox mb={2}>

              <SoftBox mb={1} ml={0.5}>

                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Price
                </SoftTypography>
              </SoftBox>
              <SoftInput

                type="number"
                name="base_price"
                placeholder="Price"
                value={formData.base_price}
                onChange={handleChange}
              />
            </SoftBox>

         <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Max Occupancy
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="number"
              name="max_occupancy"
              placeholder="Enter the max occupancy"
              value={formData.max_occupancy}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Size
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="size"
              placeholder="Enter the room size"
              value={formData.size}
              onChange={handleChange}
            />
          </SoftBox>

           <SoftBox mb={2}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Upload Images
            </SoftTypography>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleAddImages}
              style={{ marginBottom: '20px' }}
            />
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {images.map((image, index) => (
                <div key={index} style={{ position: 'relative' }}>
                  <img
                    src={image.name?URL.createObjectURL(image):image}
                    alt="Preview"
                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                  />
                  <button
                    onClick={() => handleRemoveImage(index)}
                    style={{
                      position: 'absolute',
                      top: '5px',
                      right: '5px',
                      background: 'red',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      cursor: 'pointer',
                    }}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </SoftBox>
  
            <SoftBox mt={4} mb={1}>

              <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
                Submit
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    )
}

export default EditRoomType